import { CreateIndividualProvider } from 'context-store/individual-creation/CreateIndividualProvider';
import { IndividualCreatedMessagesProvider } from 'context-store/individual-creation/IndividualCreatedMessagesProvider';
import { NavigationPromptProvider } from 'context-store/NavigationPromptProvider';
import { SearchPageProvider } from 'context-store/SearchPageProvider';
import { UserPermissionProvider } from 'context-store/user-permission/UserPermissionProvider';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { queryClient } from 'service/react-query/reactQueryConfig';
import { HeroSnackbarProvider } from 'ui/atom/snackbar/HeroSnackbarProvider';

const SearchAndCreateIndividualProvider = ({ children }) => {
  return (
    <SearchPageProvider>
      <CreateIndividualProvider>
        <IndividualCreatedMessagesProvider>
          {children}
        </IndividualCreatedMessagesProvider>
      </CreateIndividualProvider>
    </SearchPageProvider>
  );
};

export function Provider({ children }) {
  return (
    <QueryClientProvider client={queryClient}>
      <UserPermissionProvider>
        <SearchAndCreateIndividualProvider>
          <NavigationPromptProvider>
            <HeroSnackbarProvider>{children}</HeroSnackbarProvider>
          </NavigationPromptProvider>
        </SearchAndCreateIndividualProvider>
      </UserPermissionProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
